<template>
  <div id="claims-process">
    <ul>
      <li>
        <div class="count">1.</div>
        <div class="content">
          投保时，本投保人已就该产品的保障内容以及保险金额向被保险人进行了明确说明，并征得其同意。
        </div>
      </li>
      <li>
        <div class="count">2.</div>
        <div class="content">
          本投保人授权深圳市慧择保险经纪有限公司作为本人的保险经纪人，并委托深圳市慧择保险经纪全权代为办理保险相关事宜。
        </div>
      </li>
      <li>
        <div class="count">3.</div>
        <div class="content">
          本投保人兹声明上述各项内容填写属实，并知道如果投保信息不真实，保险公司将有权拒赔，一切后果由本人承担。
        </div>
      </li>
      <li>
        <div class="count">4.</div>
        <div class="content">
          本投保人已完整阅读本产品投保须知、详细条款，尤其是保障责任、免除责任、犹豫期、费用扣除、退保、保险单现金价值、投保人、被保险人义务的内容等各重要事项。本投保人特此同意接受该条款及投保须知之全部内容。
        </div>
      </li>
      <li>
        <div class="count">5.</div>
        <div class="content">
          本投保人已明确了解该保险合同的成立、生效是以保险公司出具保单为准，确认非以支付保费为保险合同的成立要件。
        </div>
      </li>
      <li>
        <div class="count">6.</div>
        <div class="content">
          本投保人已明确并接受本计划的承保机构、承保、保全变更、退保和理赔办理方式及理赔金支付方式。
        </div>
      </li>
      <li>
        <div class="count">7.</div>
        <div class="content">
          根据《中华人民共和国合同法》第十一条规定，数据电文是合法的合同表现形式。本人接受保险公司在慧择网提供的电子保单作为本投保书成立生效的合法有效凭证，具有完全证据效力。
        </div>
      </li>
      <li>
        <div class="count">8.</div>
        <div class="content">
          本投保人已知晓并确认，投保本产品时如被保险人是未成年人,
          其父母或监护人已知晓并同意投保人为该未成年人安排相关保险的承保。（如投保人已是未成年人的父母或监护人，则不适用于此条。）
        </div>
      </li>
      <li>
        <div class="count">9.</div>
        <div class="content">
          本产品为深圳市慧择保险经纪有限公司提供投保链接，相应保险经纪服务保全、理赔协助等由深圳市慧择保险经纪有限公司提供。
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import utils from '../services/tools.js';

export default {
  name: 'claimsProcess',
  created() {
    utils.setTitle('投保人申明');
  },
};
</script>

<style lang="less" scoped>
#claims-process {
  background-color: #fff;
  padding: 0.15rem;
  ul {
    li {
      font-size: 0.15rem;
      line-height: 0.2rem;
      margin-bottom: 0.2rem;
      .count {
        float: left;
        width: 0.2rem;
      }
      .content {
        margin-left: 0.2rem;
      }
    }
  }
}
</style>
